import React, { useState, useEffect } from 'react';
import { useAuth } from '../../contexts/AuthContext';
import { useSearchParams } from 'react-router-dom';
import OrganizerLayout from '../OrganizerDashboard/OrganizerLayout';
import OrganizerHome from '../OrganizerDashboard/OrganizerHome';
import OrganizerSettings from '../OrganizerDashboard/OrganizerSettings';
import Bookings from './Bookings';
import './Profile.css';
import '../OrganizerDashboard/OrganizerDashboard.css';
import '../OrganizerDashboard/OrganizerSettings.css';
import '../AuthGate/AuthGate.css';

const Profile = () => {
  const { currentUser, loading: authLoading } = useAuth();
  const [searchParams] = useSearchParams();
  const [activeSection, setActiveSection] = useState('home');

  useEffect(() => {
    const section = searchParams.get('section');
    if (section === 'bookings') {
      setActiveSection('bookings');
    } else if (section === 'account') {
      setActiveSection('account');
    } else {
      setActiveSection('home');
    }
  }, [searchParams]);

  useEffect(() => {
    if (window.innerWidth <= 768) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  }, [activeSection]);

  if (authLoading) {
    return (
      <div className="auth-gate-loading">
        <div className="auth-gate-spinner" />
        <p>Loading your profile…</p>
      </div>
    );
  }

  if (!currentUser) {
    return (
      <div className="auth-gate-loading">
        <div className="auth-gate-spinner" />
        <p>Please sign in to view your profile.</p>
      </div>
    );
  }

  const layoutNav =
    activeSection === 'bookings' ? 'bookings' : activeSection === 'account' ? 'home' : 'home';

  return (
    <OrganizerLayout activeNav={layoutNav}>
      {activeSection === 'home' && <OrganizerHome />}
      {activeSection === 'account' && <OrganizerSettings />}
      {activeSection === 'bookings' && <Bookings />}
    </OrganizerLayout>
  );
};

export default Profile;
